import { makeStyles } from 'tss-react/mui'
import { fundingColors } from '../../theme/fundingColors'
import { fundingFont, fundingType } from '../../theme/fundingTypography'

const C = {
  ...fundingColors,
  setupAccent: '#a86000',
  emailPanelBorder: '#c9cef0',
  stepCircleBg: '#e8eaf6',
  stepCircleText: '#041282',
  placeholderBg: '#ffe7d1',
  placeholderText: '#5a2e00',
}

export const useStyles = makeStyles()(() => ({
  root: {
    boxSizing: 'border-box',
    width: '100%',
    padding: '28px 32px 48px',
    maxWidth: 1200,
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    fontFamily: fundingFont,
    color: C.darkText,
    background: 'transparent',
    border: 'none',
    boxShadow: 'none',
  },
  card: {
    background: C.cardBg,
    border: 'none',
    borderRadius: 14,
    boxShadow: 'none',
    overflow: 'hidden',
  },
  intro: {
    padding: '32px 32px 8px',
    display: 'flex',
    flexDirection: 'column',
    gap: 14,
    maxWidth: 760,
  },
  eyebrow: {
    fontFamily: fundingFont,
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
    color: C.setupAccent,
  },
  title: {
    margin: 0,
    fontFamily: fundingFont,
    fontSize: 24,
    fontWeight: 600,
    lineHeight: 1.25,
    letterSpacing: '-0.01em',
  },
  body: {
    margin: 0,
    ...fundingType.body,
    color: C.mutedText,
    lineHeight: 1.6,
  },
  pills: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '10px 12px',
    paddingTop: 4,
  },
  content: {
    padding: '24px 32px 32px',
    display: 'flex',
    flexWrap: 'wrap',
    gap: 28,
    alignItems: 'flex-start',
  },
  stepsCol: {
    flex: '1 1 320px',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 18,
  },
  stepsTitle: {
    margin: 0,
    fontFamily: fundingFont,
    fontSize: 15,
    fontWeight: 600,
  },
  stepsList: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  stepItem: {
    display: 'flex',
    gap: 12,
  },
  stepNum: {
    flex: '0 0 26px',
    height: 26,
    borderRadius: '50%',
    background: C.stepCircleBg,
    color: C.stepCircleText,
    fontSize: 12,
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  stepText: {
    fontFamily: fundingFont,
    fontSize: 13,
    lineHeight: 1.55,
    color: C.mutedText,
    '& strong': {
      color: C.darkText,
      fontWeight: 600,
    },
  },
  ph: {
    background: C.placeholderBg,
    color: C.placeholderText,
    borderRadius: 4,
    padding: '1px 5px',
    fontWeight: 500,
  },
  emailCol: {
    flex: '1.5 1 440px',
    minWidth: 0,
    border: `1px solid ${C.emailPanelBorder}`,
    borderRadius: 14,
    background: C.cardBg,
    overflow: 'hidden',
  },
  emailHeader: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 10,
    padding: '14px 18px',
    borderBottom: `1px solid ${C.emailPanelBorder}`,
    background: C.cardBg,
  },
  emailHeaderTitle: {
    fontFamily: fundingFont,
    fontSize: 14,
    fontWeight: 600,
  },
  emailActions: {
    display: 'flex',
    gap: 8,
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  metaRows: {
    padding: '4px 18px',
    fontSize: 13,
    fontFamily: fundingFont,
  },
  metaRow: {
    display: 'flex',
    gap: 12,
    padding: '10px 0',
    borderBottom: `1px solid ${C.separator}`,
  },
  metaLabel: {
    flex: '0 0 56px',
    color: C.mutedText,
  },
  emailBody: {
    padding: '16px 18px 20px',
    fontFamily: fundingFont,
    fontSize: 13,
    lineHeight: 1.65,
    color: C.onSurface,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    '& p': { margin: 0 },
    '& ul, & ol': {
      margin: '4px 0 0',
      paddingLeft: 18,
    },
  },
  sectionLabel: {
    fontWeight: 600,
    color: C.darkText,
  },
  iamRoot: {
    boxSizing: 'border-box',
    width: '100%',
    padding: '48px 32px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 12,
    fontFamily: fundingFont,
  },
  iamTitle: {
    margin: 0,
    fontFamily: fundingFont,
    fontSize: 20,
    fontWeight: 600,
  },
  iamBody: {
    margin: 0,
    ...fundingType.body,
    color: C.mutedText,
    maxWidth: 520,
  },
  iamLink: {
    color: C.linkBlue,
    fontWeight: 600,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}))
